import React from "react";
import { Badge, Button, Card } from "react-bootstrap";
import { withRouter } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { CardBody } from "reactstrap";
import MUIDataTable from "mui-datatables";
//import DetailsIcon from '@material-ui/icons/Details';
import UpdateIcon from '@material-ui/icons/Update';
//import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';

class BorewellList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Data: [""], borewellEdit: [], editSlot: false, remarks: "",
      partnerId: this.props.data ? this.props.data : (this.props.location.state.data ? this.props.location.state.data : ''),
      status: ""
    };
    this.nextPath = this.nextPath.bind(this);
  }

  submitHandler = () => {
    return "/partner/borewell/borewell-create"
  }

  componentDidMount() {
    const url5 = process.env.REACT_APP_NODE_ENV + "/api/borewells/getborewellbypartnerId/" + this.state.partnerId
    fetch(url5, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => {
        if (!response.ok) throw new Error(response.status);
        else return response.json();
      }).then(data => {
        this.setState({ Data: data });
      }).catch(error => console.log(error), this.setState({ Data: [] }))
  }

  editStatusSlotHandler = value => {
    const doesToggle = this.state.editSlot;
    this.setState({ borewellEdit: value, editSlot: !doesToggle });
    this.setState({ status: value.status });
  };

  handleEditFormFields = (event) => {
    // const borewellEditCopy = this.state.borewellEdit;
    switch (event.target.id) {
      case "statusUpdate":
        //borewellEditCopy.status = event.target.value;
        this.setState({ status: event.target.value });
        //this.setState({ borewellEdit: borewellEditCopy},console.log(this.state.borewellEdit.status));
        break;
      case "remarks":
        this.setState({ remarks: event.target.value });
        break;
      default: break;
    }
  }

  save = () => {
    this.setState({ editSlot: false })
    //console.log(this.state.borewellEdit.status)
    let postOrderData = {
      id: this.state.borewellEdit.id, status: this.state.status
    };
    console.log(postOrderData);
    fetch(process.env.REACT_APP_NODE_ENV + '/api/borewells/updateBorewell', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(postOrderData)
    }).then((res) => res.json())
      .then((data) => { console.log(data); this.componentDidMount() })
      .catch((err) => console.log(err))
  };

  popUpCancel = () => {
    this.setState({ editSlot: false });
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, state: { data: value } });
  }


  delete = (id) => {
    const postBorewellData = {
      id: id
    };
    fetch(process.env.REACT_APP_NODE_ENV + '/api/borewells/deleteBorewell', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(postBorewellData)
    }).then(response => { if (response.ok) { this.componentDidMount() } })
      .catch((err) => console.log(err))
  };

  render() {

    let editSlots = null;
    if (this.state.editSlot) {
      editSlots = (
        <Modal
          isOpen={true}
          // fade={false}
          // toggle={this.to}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
              <ModalHeader> Update Status for - {this.state.borewellEdit.borewellId}</ModalHeader>
              <ModalBody>
                <><div className="col-lg-4">
                  <label> <b>Status</b> </label><select id="statusUpdate" className="form-control" value={this.state.status} onChange={this.handleEditFormFields} >
                    <option value="InActive">InActive</option>
                    <option value="Active">Active</option>
                  </select></div>
                  <div style={{ paddingTop: "20px" }} className="col-lg-8">
                    <input type="text" className="form-control" id="remarks" placeholder="Remarks" value={this.state.remarks} onChange={this.handleEditFormFields} />
                  </div></>
              </ModalBody>
              <ModalFooter>
                <Button variant="outline-primary" onClick={() => this.save()}>
                  Save
                </Button>&nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={() => this.popUpCancel()}> Cancel </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }

    let dataArr = [];
    let datas2 = this.state.Data.map((data) => {
      let variant = "";
      if (data.status === "InActive") { variant = "danger" }
      else { variant = "success" }
      let mdData = [
        data.borewellId, data.typeOfWell, data.doorNumber + ", " + data.streetName + ", " + data.area + ", " + data.city+"-"+data.pincode,
        data.capacityPerDay, <Badge pill variant={variant}>{data.status}</Badge>,  data
      ];
      dataArr.push(mdData)
    });


    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "typeOfWell",
        label: "Type Of Well",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "address",
        label: "Address",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "capacity",
        label: "Capacity",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: false,
          sort: true,
        }
      },
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                <Tooltip title="Details"><IconButton>
                  <button onClick={() => this.nextPath("/partner/borewell/borewell-details", value.id)}>D</button> </IconButton></Tooltip>
                <Tooltip title="Update Status"><IconButton>
                  <UpdateIcon onClick={() => this.editStatusSlotHandler(value)} /></IconButton></Tooltip>
                {/* <Tooltip title="Delete"><IconButton>
  <DeleteIcon onClick={() => this.delete(value.id)} /></IconButton></Tooltip> */}
              </>
            );
          }
        }
      }
    ];


    const options = {
      filterType: 'dropdown', rowsPerPageOptions: [5, 10, 15, 20], selectableRows: "none",
      onRowsDelete: (rowsDeleted) => {
        for (var key in rowsDeleted.data) {
          console.log(rowsDeleted.data[key].index)
          this.delete(dataArr[rowsDeleted.data[key].index].id)
        }
      }
    };


    return (
      <>
        <Card>
          <Card.Body>
            <Button className="float-right"
              variant="outline-success"
              style={{ marginTop: "25px", width: "150px", marginRight: "20px" }}
              onClick={() => this.nextPath("/partner/borewell/borewell-create", this.props.data)}>
              Add Borewell
                  </Button>
            <div style={{ marginTop: "10px" }}>
              {editSlots}
              <MUIDataTable
                title={"Borewell List"}
                data={dataArr}
                columns={columns}
                options={options} />

            </div>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export default withRouter(BorewellList);
